import Vuex from 'vuex'
import Vue from 'vue'
import mutations from './mutations'
import actions from './actions'
import state from './state'
import getters from './getters'
import saasConfig from './modules/saasConfig'

Vue.use(Vuex)
const store = new Vuex.Store({
  state,
  modules: {
    saasConfig
  },
  mutations,
  actions,
  getters
})

export default store
